module.exports = __webpack_public_path__ + "img/img_promotion_pop_main_kt.7b2a5d7f.png";